import _ from "lodash";

export default class StageService {
  static getStageByName = (stages, stageName) => {
    let stage = null;
    stageName = stageName.toLowerCase();
    stageName = stageName.trim();
    stage = _.filter(stages, (stageItme) => {
      return stageItme[`name_en`].toLowerCase() === stageName;
    });
    return stage[0] ? stage[0] : null;
  };
}
